import axios, { AxiosError } from 'axios';
import { auth } from '../firebase'; // your firebase.ts file

interface ApiError {
  message?: string;
}

export const backendAPI = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  withCredentials: true,
});


type Client = {
  id?: number;
  name?: string;
  email: string;
  phone?: string;
  country?: string;
}


export const get_client = async (businessId: number, clientId: number) => {
  try {
    const user = auth.currentUser;
    if (!user) throw new Error("User not logged in");
    const idToken = await user.getIdToken();

    const response = await backendAPI.get('clients', {
      params: { businessId, clientId },
      headers: { Authorization: `Bearer ${idToken}` },
    });

    return response.data;
  } catch (error: any) {
    throw new Error(
      (error as AxiosError<ApiError>)?.response?.data?.message || 'Get client failed'
    );
  }
};

export const get_all_clients = async (businessId: number) => {
  try {
    const user = auth.currentUser;
    if (!user) throw new Error("User not logged in");
    const idToken = await user.getIdToken();

    const response = await backendAPI.get('clients/all', {
      params: { businessId },
      headers: { Authorization: `Bearer ${idToken}` },
    });

    return response.data;
  } catch (error: any) {
    throw new Error(
      (error as AxiosError<ApiError>)?.response?.data?.message || 'Get all clients failed'
    );
  }
};

export const create_client = async (businessId: number, payload: Client) => {
  try {
    const user = auth.currentUser;
    if (!user) throw new Error("User not logged in");
    const idToken = await user.getIdToken();

    const fullPayload = {
      ...payload,
      businessId, // 👈 inject businessId into request body
    };

    const response = await backendAPI.post('clients', fullPayload, {
      headers: { Authorization: `Bearer ${idToken}` },
    });

    return response.data;
  } catch (error: any) {
    throw new Error(
      (error as AxiosError<ApiError>)?.response?.data?.message || 'Create client failed'
    );
  }
};

export const update_client = async (
  clientId: number,
  userBusinessId: number,
  payload: Client
) => {
  try {
    const user = auth.currentUser;
    if (!user) throw new Error("User not logged in");
    const idToken = await user.getIdToken();

    const fullPayload = {
      ...payload,
      businessId: userBusinessId, // include businessId
    };

    const response = await backendAPI.put(
      `clients/${clientId}`,
      fullPayload,
      {
        headers: { Authorization: `Bearer ${idToken}` },
      }
    );

    return response.data;
  } catch (error: any) {
    throw new Error(
      (error as AxiosError<ApiError>)?.response?.data?.message || 'Update client failed'
    );
  }
};

export const delete_client = async (
  userBusinessId: number,
  clientId: number
) => {
  try {
    const user = auth.currentUser;
    if (!user) throw new Error("User not logged in");
    const idToken = await user.getIdToken();

    const response = await backendAPI.delete(
      `clients/${clientId}`,
      {
        headers: { Authorization: `Bearer ${idToken}` },
        data: { userBusinessId }, // pass body in DELETE if needed
      }
    );

    return response.data;
  } catch (error: any) {
    throw new Error(
      (error as AxiosError<ApiError>)?.response?.data?.message || 'Delete product failed'
    );
  }
};
